import { render } from "./FooterNr1.vue?vue&type=template&id=2d512369&scoped=true"
import script from "./FooterNr1.vue?vue&type=script&lang=js"
export * from "./FooterNr1.vue?vue&type=script&lang=js"

import "./FooterNr1.vue?vue&type=style&index=0&id=2d512369&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d512369"]])

export default __exports__